export var MarketTypes;
(function (MarketTypes) {
    MarketTypes["ALL"] = "ALL";
    MarketTypes["STOCK"] = "Stock";
    MarketTypes["FUTURES"] = "Futures";
    MarketTypes["FOREX"] = "Forex";
    MarketTypes["CFD"] = "CFD";
    MarketTypes["CRYPTO"] = "Crypto";
    MarketTypes["INDEX"] = "Index";
    MarketTypes["ECONOMIC"] = "Economic";
})(MarketTypes || (MarketTypes = {}));
//# sourceMappingURL=markets.js.map